export default {
  filterModes: {
    label: 'Tryb',
    options: {
      like: 'Zawiera',
      equals: 'Jest równe',
      list: 'Lista',
    },
  },
  noItemsSelected: 'Nie wybrano żadnego elementu',
  confirm: 'Czy na pewno chcesz to zrobić?',
  fields: {
    action: 'Akcja',
    status: 'Status',
  },
  status: {
    title: 'Statusy',
    active: 'Aktywne',
    inactive: 'Nieaktywne',
  },
  searchByColumns: 'Szukaj w wybranych kolumnach',
  search: 'Szukaj',
  noMatchingResults: 'Nie znaleziono pasujących rekordów',
  noDataAvailable: 'Brak danych',
  rowsPerPageText: 'Rekordów na stronę:',
  records: 'Rekordy',
  page: 'Strona',
  from: 'z',
  add: 'Dodaj',
  all: 'Wszystko',
  buttons: {
    edit: 'Edytuj',
    suspend: 'Zawieś',
    restore: 'Przywróć',
    delete: 'Usuń',
    editSelected: 'Edytuj zaznaczone',
    suspendSelected: 'Zawieś zaznaczone',
    restoreSelected: 'Przywróć zaznaczone',
    deleteSelected: 'Usuń zaznaczone',
    download: 'Pobierz',
    show: 'Pokaż',
    refreshTable: 'Odswież tabelę',
    copyToExcel: 'Kopiuj do Excela',
    clearFilters: 'Wyczyść filtry',
    move: 'Przenieś',
    insert: 'Wstaw',
    insertUnassigned: 'Wstaw bez przypisania',
    cancelMove: 'Anuluj przenoszenie',
  },
}
